import { css } from 'styled-components';
import { Color } from 'styled/theme/colors';

export const svgHoverColor = (color: Color) => css`
  path {
    ${({ theme }) => theme.transitions['transition']};
  }

  :hover {
    path {
      fill: ${({ theme }) => theme.colors[color]};
    }
  }
`;
